











 













const node = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "meetingId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutcomeCardContainer_task",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskEditorDetails",
      "kind": "LinkedField",
      "name": "editors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userId",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "meetingId",
          "variableName": "meetingId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "OutcomeCard_task"
    }
  ],
  "type": "Task",
  "abstractKey": null
};

(node ).hash = "f68d5c691c94307229e73b86d4ca9651";

export default node;
